import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getReferenceTreeForTalkingPoint, type TopicDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useReferenceTreeForTalkingPoint(talkingPointId?: number): UseQueryResult<TopicDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.talkingPointReferenceTree(talkingPointId), [talkingPointId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getReferenceTreeForTalkingPoint({ path: { 'talking-point-id': talkingPointId! }, signal }).then((res) => res.data),
        enabled: !!talkingPointId,
    });
}
